// @module Tavano.HubspotPDP.HubspotPDPExt
define('Tavano.HubspotPDP.HubspotPDPExt.View'
,	[
		'SCView'

	,	'tavano_hubspotpdp_hubspotpdp_view.tpl'
	
	,	'Backbone'
    ]
, function (
		SCViewComponent

	,	tavano_hubspotpdp_hubspotpdp_view_tpl
	
	,	Backbone
)
{
    'use strict';

	var SCView = SCViewComponent.SCView;

	function HubSpotPDPView(options)
	{
		SCView.call(this, options);

		this.template = tavano_hubspotpdp_hubspotpdp_view_tpl;

		this.application = options.container;
		this.layoutComp = this.application.getComponent('Layout')
		this.env = this.application.getComponent('Environment');

		this.contextDataRequest = ['item'];
	}

	HubSpotPDPView.prototype = Object.create(SCView.prototype);

	HubSpotPDPView.prototype.constructor = HubSpotPDPView;

	HubSpotPDPView.prototype.getContext = function()
	{
		return {
			hubspoturl: this.contextData.item().custitem_tt_sca_hubspot_url
		,	openNewTab: this.env.getConfig('TTHubspotPdp.newtab')
		}
	}

	return HubSpotPDPView;
});
